import AuctionRules from 'components/Auctions/AuctionRules';
import { nl2br } from 'public/static/js/Utils';

const AuctionDetails = ({ auction }) => {
    const renderCategories = () => {
        const _categories = auction?.categories;
        const _length = _categories?.length;

        return (
            _categories?.map((cat, idx) => {
                return idx === 0 && _length === 2 ? (
                    <p className="inline-category"> {cat.category_name.toLowerCase()} and {' '}</p>
                ) : idx + 1 === _length && _length > 5 ? (
                    <p className="inline-category"> {cat.category_name.toLowerCase()}, and much more.</p>
                ) : idx + 1 === _length && _length > 2 ? (
                    <p className="inline-category"> and {' '}{cat.category_name.toLowerCase()}.</p>
                ) : idx + 1 === _length ? (
                    <p className="inline-category"> {cat.category_name.toLowerCase()}.</p>
                ) : idx < 4 ? (
                    <p className="inline-category"> {cat.category_name.toLowerCase()},</p>
                ) : null;
            })
        );
    };

    return (
        <>
            <div className="row-md">
                <h2 className="section-title">
                    Auction Details
                </h2>
            </div>
            <div className="knowledge-wrapper marginB25 paddingT15">
                <p>You are viewing a self storage auction located at {auction?.address}, {auction?.city}, {auction?.state} {auction?.zipcode}.
                    This online auction is being hosted by {auction?.facility_name}. The content of this {auction?.unit_width} x {auction?.unit_length} (approx. size) storage unit appears to contain{renderCategories()} Be sure to bid now,
                    as this auction ends on {auction?.expire_date?.user?.formatted}, time is running out. Happy Bidding!</p>
            </div>
            <div className="row-md">
                {auction?.unit_additional ? (
                    <h2 className="section-title">
                        Additional Information
                    </h2>
                ) : ''}
            </div>
            <div className="knowledge-wrapper marginB25 paddingT15">
                <p dangerouslySetInnerHTML={{ __html: nl2br(auction?.unit_additional) }} />
            </div>
            <div className="row-md">
                <h2 className="section-title">
                    {auction?.type_id != '3' ? 'Auction Rules' : 'Charity Unit Auction Rules'}
                </h2>
            </div>
            <div className="knowledge-wrapper marginB25 paddingT15">
                <AuctionRules isCharity={auction?.type_id == '3'} />
            </div>
        </>
    );
};

export default AuctionDetails;